import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateSupplierLegalModel,
  CreateSupplierModel,
  CreateSupplierNaturalModel,
  DeleteSupplierLegalModel,
  DeleteSupplierModel,
  DeleteSupplierNaturalModel,
  SearchSupplierLegalModel,
  SearchSupplierModel,
  SearchSupplierNaturalModel,
} from '../../../models/supplier.model'

@Injectable({
  providedIn: 'root',
})
export class SupplierService {
  private baseUrl = environment.baseUrl
  private resourceLegal: string = 'equipamentos'
  private resource: string = 'equipamentos'

  constructor(private httpClient: HttpClient) {}


  public searchPagedSupplier(
    page: number,
    rows: number = 15,
    model: SearchSupplierModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  /*  Supplier Natural  */



  public editSupplierNatural(
    model: any,
    // model: EditSupplierNaturalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }







  /*  Supplier Legal  */

  public createSupplierLegal(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/create`,
      model,
    )
  }

  public editSupplierLegal(
    model: any,
    // model: EditSupplierLegalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/update`,
      model,
    )
  }

  public deleteSupplierLegal(
    model: DeleteSupplierLegalModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/delete`,
      model,
    )
  }

  public listPagedSupplierLegal(
    page: number,
    rows: number = 10,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/list?page=${page}&per_page=${rows}`,
    )
  }

  public listEquipments(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/list`,
    )
  }
  public listEquipmentsByTypeExam(id_tipo_exame: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/TipoExame/${id_tipo_exame}`,
    )
  }

  public getSupplierLegalbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/${id}`,
    )
  }

  public searchPagedSupplierLegal(
    page: number,
    rows: number = 10,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceLegal}/list?pageNumber=${page}&pageSize=${rows}&numero_serial=${model.numero_serial}&modelo=${model.modelo}`
    )
  }
}
